import React from 'react'
import { Link } from 'react-router-dom'

const SideBarLink = ({ to, closeWithClick, activeTab,name,LinkIcon }) => {

    return (
        <Link
            data-testid="plan-setting-link"
            to={to}
            onClick={closeWithClick}
            className={activeTab? "active" : ""}
        >
          { LinkIcon && <LinkIcon className="slide-bar-icons" />} {name}
        </Link>
    )
}

export default SideBarLink